import { requst } from '../config'

// 查询 id
export const getFocusAcquisitionByDateApi = params => {
    const url = `/quake/source/getInfo?produceDate=${params.produceDate}&projectId=${params.projectId}`
    return requst.get(url)
}

// 日历上数据
export const getFocusAcquisitionCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/quake/source/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getFocusAcquisitionDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}


// 提交 FocusAcquisition 数据
export const postFocusAcquisitionDataApi = (FocusAcquisitionParams) => {
    const url = `/quake/source/save`
    return requst.post(url, FocusAcquisitionParams)
}

// 上传文件
export const postQuakeFileDataApi = (params, file) => {
    const url = `/quake/source/importData`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params,
        data: formData,
    })
}

// 上传文件 step 2
export const postQuakeSourceFileDataApi = (file, projectId, additional) => {
    const url = `/file/upload?projectId=${projectId}&additional=${additional}`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}


// 新增震源文件
export const postFocusAcquisitioSourceFileApi = (params) => {
    const url = `/quake/source/file/save`
    return requst.post(url, params)
}

// 查询震源文件
export const postFocusSourceFileListApi = (fileListParams) => {
    const url = `/quake/source/file/list?produceDate=${fileListParams?.produceDate}&projectId=${fileListParams?.projectId}`
    return requst.get(url)
}

// 查询 解析后的 震源文件
export const getFocusSourceFileListApi = (quakeSouceFileIdList) => {
    const ids = quakeSouceFileIdList.join(',')
    const url = `/landnode/file/analysis?quakeSouceFileIdList=${ids}`
    return requst.get(url)
}

// 查询 解析后的 vpreport文件
export const getFocusVPFileListApi = (projectId, produceDate) => {
    const url = `/quake/source/analysisVPReport?projectId=${projectId}&produceDate=${produceDate}`
    return requst.get(url)
}

// 删除震源文件
export const deleteFocusSourceFileListApi = (fileId) => {
    const url = `/quake/source/file/delete?id=${fileId}`
    return requst.delete(url)
}

// 下载震源文件
export const downFocusSourceFileListApi = (fileId) => {
    const url = `/file/download?id=${fileId}`
    return requst.get(url, {
        responseType: 'blob',
    })
}

// 下载文件
export const downFocusFileApi = id => {
    const url = `/quake/source/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}